import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { DialogOfficeHoursComponent } from '../../components/dialog-office-hours/dialog-office-hours.component';

@Component({
  standalone: false,
  selector: 'sbnb-schedule-call',
  templateUrl: './schedule-call.component.html',
  styleUrls: ['./schedule-call.component.scss'],
})
export class ScheduleCallComponent {
  constructor(
    private readonly dialog: MatDialog,
    private router: Router
  ) { }

  openVideos() {
    this.router.navigate(['/support-documentation/article/5544651-getting-started']);
  }

  openOfficeHoursModal() {
    this.dialog.open(DialogOfficeHoursComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: true,
    });
  }
}
